<template>
  <div ref="wrapperRef" class="notification-wrapper">
    <div class="notification-content-icon">
      <IconLiveStream v-if="props.notification.data.contenttype === 'universal'" />
      <IconNewspasper v-if="props.notification.data.contenttype === 'aksi' || props.notification.data.contenttype === 'agenda'" />
      <IconPolling v-if="props.notification.data.contenttype === 'polling'" />
    </div>
    <div class="notification-content" @click="handleClick">
      <span class="notification-content__title">
        {{ props.notification.notification.title }}
      </span>
      <span class="notification-content__date">
        {{ helper.methods.convertDateNotification(props.notification.data.contenttype === 'universal' ? props.notification.data.startdate  : (props.notification.data.contentdate || null )) }}
      </span>
      <span class="notification-content__body">
        {{ props.notification.notification.body }}
      </span>
    </div>
  </div>
</template>
<script setup>
import { defineEmit, defineProps, ref } from 'vue'
// import { useRouter } from 'vue-router'
import helper from '../mixins/helper'
import IconLiveStream from './Notification/icons/IconLiveStream.vue'
import IconNewspasper from './Notification/icons/IconNewspasper.vue'
import IconPolling from './Notification/icons/IconPolling.vue'

const props = defineProps({
  notification: Object,
  key: Number
})

const wrapperRef = ref(null)

// const router = useRouter()

const emit = defineEmit(['close-notification'])

const close = () => emit('close-notification', props.notification.fcmMessageId)

const handleClick = () => {
  const { contenttype } = props.notification.data
  if (contenttype === 'polling') {
    // TODO
    // router.push({ name: 'polls', params})
  }
  window.open(props.notification.data?.url || props.notification.notification?.click_action, '_blank')
  close()
}

</script>

<style lang="scss">
.notification-wrapper {
  opacity: 100;
  max-width: 400px;
  z-index: 99991 !important;
  padding: 1em !important;
  // box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;
  border-radius: 10px;
  display: flex;
}

.notification-content-icon {
  cursor: pointer;
  display: flex;
  flex-direction: column;
  margin-right: 1em;
}

.notification-content {
  text-overflow: ellipsis;
  cursor: pointer;
  display: flex;
  flex-direction: column;

  &__title {
    font-weight: 600;
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }

  &__body {
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }

  &__date {
    color: $red;
  }
}

.notification-action {
  background-color: $red;
  justify-content: center;
  align-items: center;
  align-content: center;
  padding: .4em;
  cursor: pointer;
  display: flex;

  div {
    color: $white;
    font-weight: 600;
    font-size: 23px;
    place-self: center;
  }
}
</style>
